module.exports = __webpack_public_path__ + "img/chat-white.44f2aa68.svg";